module.exports = __webpack_public_path__ + "img/advantage.710b80ca.png";